import { gql } from '@apollo/client';

export class AnalyticsGQLFunction {
  static LAT_LONG_DATA = gql`
    query UALogsWithLatLongbyTime($start: String!, $end: String!, $lastId: String, $limit: Int) {
      UALogsWithLatLongbyTime(start: $start, end: $end, lastId: $lastId, limit: $limit) {
        LENGTH
        UALogs {
          id
          lat
          lng
          t
        }
        MORE
      }
    }
  `;

  static GET_DASHBOARD_DATA = gql`
    query dashboardData($start: String!, $end: String!, $startMonth: String!, $endMonth: String!) {
      dauOfDays(start: $start, end: $end) {
        dateOfData
        data
      }
      mauOfMonths(start: $startMonth, end: $endMonth) {
        monthOfData
        data
      }
      latestDau
      latestMau
      totalUsersCount
      totalMessagesCount
      timezonesOfUsers(start: $start, end: $end) {
        timezone
        count
      }
    }
  `;

  static SYNC_UA_LOGS_LOCATION = gql`
    mutation syncUALogsLocation($start: String!, $end: String!) {
      syncUALogsLocation(start: $start, end: $end)
    }
  `;
}
